module.exports = __webpack_public_path__ + "static/media/mantra@x1.b5cb36c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/mantra@x1.png
// module id = 547
// module chunks = 0